import { WIDGET_TAG_THRESHOLDS } from '@solinkcorp/vd-common';

export const DASHBOARD_TAB = {
  MAIN: 'main',
  AI: 'ai',
  ALARMS: 'alarms',
  APPLE_TV: 'appleTV',
  DELIVERY: 'delivery',
  DRIVE_THRU: 'driveThru',
  HEALTH: 'health',
  REVENUE: 'revenue',
  ALL: 'all',
  THRESHOLDS: WIDGET_TAG_THRESHOLDS,
};

export type DashboardTab =
  | typeof DASHBOARD_TAB.MAIN
  | typeof DASHBOARD_TAB.ALARMS
  | typeof DASHBOARD_TAB.APPLE_TV
  | typeof DASHBOARD_TAB.DELIVERY
  | typeof DASHBOARD_TAB.DRIVE_THRU
  | typeof DASHBOARD_TAB.HEALTH
  | typeof DASHBOARD_TAB.REVENUE
  | typeof DASHBOARD_TAB.ALL;

export const ALWAYS_DISPLAY_TABS = [DASHBOARD_TAB.AI, DASHBOARD_TAB.THRESHOLDS];
